import React, { useState, useEffect } from 'react';
import { Tabs } from 'antd';
import { AppstoreOutlined, ToolOutlined, ShoppingOutlined, ShopOutlined, EnvironmentOutlined, FileTextOutlined } from '@ant-design/icons';
import { useLocation, useNavigate } from 'react-router-dom';
import WorkTypeCategoriesTab from './WorkTypeCategoriesTab';
import PartCategoriesTab from './PartCategoriesTab';
import SupplierCategoriesTab from './SupplierCategoriesTab';
import EquipmentCategoriesTab from './EquipmentCategoriesTab';
import LocationCategoriesTab from './LocationCategoriesTab';
import DocumentCategoriesTab from './DocumentCategoriesTab';
import { PageHeader, PageContainer, DevFilePathBadge } from '../../components/common';

const CategoriesPage: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // URLハッシュから初期タブを決定
  const getInitialTab = () => {
    const hash = location.hash.replace('#', '');
    const validTabs = ['location', 'equipment', 'work-type', 'part', 'supplier', 'document'];
    return validTabs.includes(hash) ? hash : 'location';
  };

  const [activeTab, setActiveTab] = useState(getInitialTab());

  // タブ変更時にURLハッシュを更新
  const handleTabChange = (key: string) => {
    setActiveTab(key);
    navigate(`#${key}`, { replace: true });
  };

  // URLハッシュが変更された時にタブを更新（ブラウザの戻る/進む対応）
  useEffect(() => {
    const hash = location.hash.replace('#', '');
    if (hash && hash !== activeTab) {
      const validTabs = ['location', 'equipment', 'work-type', 'part', 'supplier', 'document'];
      if (validTabs.includes(hash)) {
        setActiveTab(hash);
      }
    }
  }, [location.hash, activeTab]);

  const items = [
    {
      key: 'location',
      label: (
        <span>
          <EnvironmentOutlined />
          エリアカテゴリ
        </span>
      ),
      children: <LocationCategoriesTab />,
    },
    {
      key: 'equipment',
      label: (
        <span>
          <AppstoreOutlined />
          設備カテゴリ
        </span>
      ),
      children: <EquipmentCategoriesTab />,
    },
    {
      key: 'part',
      label: (
        <span>
          <ShoppingOutlined />
          部品・消耗品カテゴリ
        </span>
      ),
      children: <PartCategoriesTab />,
    },
    {
      key: 'supplier',
      label: (
        <span>
          <ShopOutlined />
          業者カテゴリ
        </span>
      ),
      children: <SupplierCategoriesTab />,
    },
    {
      key: 'work-type',
      label: (
        <span>
          <ToolOutlined />
          作業カテゴリ
        </span>
      ),
      children: <WorkTypeCategoriesTab />,
    },
    {
      key: 'document',
      label: (
        <span>
          <FileTextOutlined />
          書類カテゴリ
        </span>
      ),
      children: <DocumentCategoriesTab />,
    },
  ];

  return (
    <PageContainer>
      <DevFilePathBadge filePath="client/src/pages/settings/CategoriesPage.tsx" />
      <PageHeader
        title="カテゴリ管理"
        subtitle="設備、部品・消耗品、業者、作業のカテゴリを一元管理します"
      />

      <Tabs
        activeKey={activeTab}
        onChange={handleTabChange}
        items={items}
        size="large"
      />
    </PageContainer>
  );
};

export default CategoriesPage;
